export default "__VITE_PUBLIC_ASSET__17373938__"